<template>

  <div class="corretiva-subgrupo ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->


              <b-col cols="1">
                <br>
                <b-button variant="warning" class="ml-5 mt-2" v-b-modal.modal-multi-subgrupo @click="reset()">Novo</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">      
    </div>    
    <!--tbl de dados -->
    <b-table id="subgrupo"  small hover striped sticky-header="550px"  :items="subgrupo" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="editSubGrupo(data.item)"    title="Editar SubGrupo"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-subgrupo>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA SUBGRUPO CORRETIVA -->
      <!--  MODAL GRAVAÇÃO RELACAO DA SUBGRUPO CORRETIVA -->
      <div>        
    <b-modal id="modal-multi-subgrupo"   hide-footer size="lg" title="Cadastro de SubGrupos">
          <!-- -->
          <div>
            <b-row>
              <b-col cols="5">
                <label for="input-grupo">Grupo</label>  -- {{subgrupo.id_grupo}}
                <div>                
                  <b-form-select                  
                    v-model="subgrup.id_grupo"                                                     
                    :options="grupos"
                    class="mb-3 "
                    text-field="grupo"
                    >                
                  </b-form-select>
                </div>
              </b-col>  
            </b-row>


            <b-row>
              <b-col cols="9">
                <label for="input-live">SubGrupo</label>
                <b-form-input v-model="subgrup.subgrupo" placeholder="Digite a descrição do subgrupo"></b-form-input>              
              </b-col>
          
          </b-row>  
          <input  id="id-subgrupo" type="hidden" v-model="subgrupo.id_subgrupo" />
         
             <b-button class="mt-3" variant="success" block @click="postSubGrupo()">Gravar</b-button>            
          </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA SUBGRUPO INDISPONIVEL -->
  </div>  
</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
//import Multiselect from 'vue-multiselect'
import moment from 'moment'




export default {    
    name: 'ManutencaoSUBgrupo',    

    data: function() {

        
      
        return {                        
            carregando: false,            
            grupos:[],                    
            subgrup:{},
            subgrupo: [],   // [] lista   
            value_grupo: '',                     
            
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            fields: [
                { key: 'id_grupo', label: 'Id_grupo', sortable: true },     
                { key: 'grupo', label: 'Grupo', sortable: true },   
                { key: 'id_subgrupo', label: 'Id_subgrupo', sortable: true },     
                { key: 'subgrupo', label: 'SubGrupo', sortable: true },                                         
                
                { key: 'dt_cadastro', label: 'Data Cadastro', sortable: true, formatter: (value, key, subgrupo) => {
                    return moment(subgrupo.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'dt_alteracao', label: 'Data Alteracao', sortable: true, formatter: (value, key, subgrupo) => {
                    return moment(subgrupo.dt_alteracao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'actions', label: 'Ações' },
                
            ]
        }        
    },

    components: {
        
    },
    methods: {

      loadGrupo() {          
          const url = `${baseApiUrl}/manutencao/corretiva/grupo`
          axios.get(url).then(res => {
            this.grupos = res.data.map(gru => {              
              return { ... gru, value: gru.id_grupo, grupo: gru.grupo  }
            })
          })
        },  


        loadSubGrupo() {          
          const url = `${baseApiUrl}/manutencao/corretiva/subgrupo`
          axios.get(url).then(res => {
            this.carregando = false;       
            this.subgrupo = res.data.map(subgrup => {              
              return { ... subgrup}
            })
          })
        },  

        editSubGrupo(subgrup){
            this.subgrup = { ...subgrup }
        },

          
        postSubGrupo() {                        
        let corpo = {                 
              "id_grupo": `${this.subgrup.id_grupo}`,     
              "id_subgrupo": `${this.subgrup.id_subgrupo}`,                         
              "subgrupo": `${this.subgrup.subgrupo}`
        };

        const url = `${baseApiUrl}/manutencao/corretiva/subgrupo`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset() //limpar os objetos valores
                })
                .catch(showError)
        },

        reset() {  
            this.subgrup = {}          
            this.subgrupo = []
            this.loadSubGrupo()            
        }
       
    },



    mounted() {  
      this.loadGrupo()
      this.loadSubGrupo()
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#grupos{   
    font-size: 0.9em;      
    text-align: center;
    
}




</style>